import { HTMLAttributes } from 'preact/compat'
import './index.css'

// Extend HTMLAttributes with anchor-specific attributes
interface LinkProps extends HTMLAttributes<HTMLAnchorElement> {
  href: string
  target?: string
  rel?: string
}

const Link = (props: LinkProps) => {
  return <a className="link" {...props} />
}

export default Link
